// extracted by mini-css-extract-plugin
export default {"card":"CardStep_card__qSdSi","cardVisited":"CardStep_cardVisited__nRyQ+","box":"CardStep_box__8L36V","number":"CardStep_number__jKxAO","title":"CardStep_title__Hmzez"};